import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'

interface IntroSectionProps {
  onCtaClick: () => void
}

// Intro block (Figma 5595:12079): green gradient, partially bold copy and
// the main participation CTA.
const IntroSection = ({ onCtaClick }: IntroSectionProps) => {
  return (
    <section className="pitstops__intro">
      <h2 className="pitstops__intro-title">
        {textServices.findByText('pitstops/intro/titleStart', 'Heineken te lleva a la experiencia más ')}
        <strong>{textServices.findByText('pitstops/intro/titleBold1', 'exclusiva')}</strong>
        {textServices.findByText('pitstops/intro/titleMiddle', ' de ')}
        <strong>{textServices.findByText('pitstops/intro/titleBold2', 'F1®')}</strong>
      </h2>
      <p className="pitstops__intro-text">
        <strong>
          {textServices.findByText(
            'pitstops/intro/textBold1',
            'En cada Pit Stop participa por 1 de los 5 pases dobles para Foro Sol'
          )}
        </strong>
        {textServices.findByText(
          'pitstops/intro/textMiddle',
          ' y completa todo el recorrido para llegar a la gran final, donde podrás competir por un '
        )}
        <strong>{textServices.findByText('pitstops/intro/textBold2', 'pase doble al Grandstand.')}</strong>
      </p>
      <button
        type="button"
        className="home-v3__button pitstops__cta"
        onClick={() => {
          dlTrackEvent('user_interaction', { action: 'click', element: 'intro :: quiero participar', section: 'pitstops' })
          onCtaClick()
        }}
      >
        {textServices.findByText('pitstops/intro/cta', '¡Quiero participar!')}
      </button>
    </section>
  )
}

export default IntroSection
